import { useTheme } from '@mui/material/styles';
import './font';
import { iconAliases } from './iconAliases';
import type { IconAliasName, IconColor, IconProps, IconSize } from './types';

const sizes: Record<IconSize, number> = {
  xsmall: 18,
  small: 20,
  medium: 24,
  large: 32,
  xlarge: 48,
  xxlarge: 64,
};

// Icon reference:
// https://fonts.google.com/icons?icon.platform=web&icon.style=Rounded
export function MaterialSymbolIcon({
  name,
  fill,
  size = 'medium',
  color,
  cursor,
  className,
  style,
  ...rest
}: IconProps) {
  const iconName = iconAliases[name as IconAliasName] ?? name;

  return (
    <span
      {...rest}
      className={['material-symbols-rounded', className]
        .filter(Boolean)
        .join(' ')}
      style={{
        ...style,
        fontVariationSettings: `'FILL' ${fill ? 1 : 0}`,
        fontSize: sizes[size],
        color: useIconColor(color),
        cursor,
      }}
    >
      {iconName}
    </span>
  );
}

const useIconColor = (color?: IconColor) => {
  const theme = useTheme();
  switch (color) {
    case 'action.active':
      return theme.palette.action.active;
    case 'disabled':
      return theme.palette.action.disabled;
    case 'error':
      return theme.palette.error.main;
    case 'primary':
      return theme.palette.primary.main;
    case 'success':
      return theme.palette.success.main;
    case 'warning':
      return theme.palette.warning.main;
    case 'text.secondary':
      return theme.palette.text.secondary;
    default:
      return undefined;
  }
};
